import { inject, injectable } from 'inversify';

import { History } from '@vk-hr-tek/core/history';
import { RoleService } from '@vk-hr-tek/core/http';

import { SettingsVacationsRouter } from '../../../settings/types';
import { modules } from '../../modules';

@injectable()
export class SettingsVacationsRouterService implements SettingsVacationsRouter {
  constructor(
    @inject(History) private history: History,
    @inject(RoleService) private readonly role: RoleService,
  ) {}

  goToCreate(companyId: string) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.settings_vacations.basename
      }/create?company_id=${companyId}`,
    );
  }

  goToEditDeadlines({ id, companyId }: { id: string; companyId: string }) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.settings_vacations.basename
      }/${id}/edit-deadlines?company_id=${companyId}`,
    );
  }

  goToList(query?: string) {
    if (!query || query === '?') {
      this.history.push(
        `/${this.role.get()}/${modules.settings.basename}/${
          modules.settings_vacations.basename
        }`,
      );
      return;
    }

    this.history.push({
      pathname: `/${this.role.get()}/${modules.settings.basename}/${
        modules.settings_vacations.basename
      }`,
      search: query.startsWith('?') ? query : `?${query}`,
    });
  }

  redirectToHome() {
    this.history.push('/');
  }

  goToScheduleDetail({ id, companyId }: { id: string; companyId: string }) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.settings_vacations.basename
      }/${id}?company_id=${companyId}`,
    );
  }

  goToStartSchedule({ id, companyId }: { id: string; companyId: string }) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.settings_vacations.basename
      }/${id}/start?company_id=${companyId}`,
    );
  }

  goToAddEmployees({ id, companyId }: { id: string; companyId: string }) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.settings_vacations.basename
      }/${id}/add-employees?company_id=${companyId}`,
    );
  }

  goToAddUnits({ id, companyId }: { id: string; companyId: string }) {
    this.history.push(
      `/${this.role.get()}/${modules.settings.basename}/${
        modules.settings_vacations.basename
      }/${id}/add-units?company_id=${companyId}`,
    );
  }

  goBack(prevState: { pathname: string; search: string }) {
    this.history.push(prevState);
  }
}
